<template>
  <div>
    <div>
      <PechatLogo :type="true" />
    </div>
    <div v-if="data.doc_type == 'default'">
      <div class="bayonnoma-style">
        <div
          style="font-size: 35px; font-weight: 600; margin-top: 30px; text-align: center; font-family: 'Times New Roman';"
        >
          BEMORNING TIBBIY BAYONNOMASI №
        </div>
  
        <label>Shifoxonaga yotqizilgan kun: {{ selectShablonJson.value1 }}</label>
  
        <label
          >Shifoxonadan chiqarilgan kun:
          {{
            selectShablonJson.value2 ? selectShablonJson.value2 : "_____________"
          }}
        </label>
        <br />
        <label>
          {{ selectShablonJson.value3 }} bo'lim, xona №
          {{ selectShablonJson.value4 }}</label
        >
        <div>
          <label>Bo'limga {{ selectShablonJson.value5 }}</label>
          <label>o'tkazilgan {{ selectShablonJson.value6 }}</label>
          <label>kun yotib davolangan</label>
        </div>
        <label>Bemorni olib yurish turlari: {{ selectShablonJson.value7 }}</label>
        <div class="display-flex">
          <label>Qon guruhi: {{ selectShablonJson.value8 }}</label>
          <label>rezus mansubligi {{ selectShablonJson.value9 }}</label>
        </div>
        <label>Dorilarning nojo'ya ta'siri {{ selectShablonJson.value10 }}</label>
  
        <div>
          <label>1. F.I.O: {{ data.bemor.fullname }}</label>
          <label>2. Jinsi: {{ data.bemor.gender }}</label>
          <label>3. Tug'ilgan kuni: {{ data.bemor.birthday | dateFormat }}</label>
          <br />
          <label>4. Bo'yi: {{ selectShablonJson.value11 }}</label>
          <label>vazni {{ selectShablonJson.value12 }}</label>
          <label>tana harorati {{ selectShablonJson.value13 }}</label>
          <br />
          <label>
            5. Doimiy yashash joyi
            {{ data.bemor.region ? data.bemor.region.name : "" }}
            {{ data.bemor.district ? data.bemor.district.name : "" }}
            {{ data.bemor.addres }}
          </label>
          <br />
          <label
            >6. Ish joyi, kasbi, lavozimi {{ selectShablonJson.value14 }}</label
          >
        </div>
        <div class="display-flex">
          <label
            >7. Bemor qayerdan yuborilgan {{ selectShablonJson.value15 }}</label
          >
        </div>
        <div class="display-flex">
          <label
            >8. Shifoxonaga shoshilinch ravishda keltirilgan:
            {{ selectShablonJson.value16 }}</label
          >
        </div>
        <div style="margin-left: 20px;">
          <label>Qanday transportda {{ selectShablonJson.value17 }}</label
          ><br />
          <label>Kasallik boshlangandan so'ng o'tgan vaqt{{ selectShablonJson.value18 }}</label>
        </div>
        <div>
          <label>Bemor yo'llanmasidagi tashxis: {{ selectShablonJson.value19 }}</label>
        </div>
      </div>
      <div>
        <label>Sana {{ selectShablonJson.value21 }}</label>
        <h3 style="text-align: center; font-family: 'Times New Roman';">
          Qabulxona shifokorining yozuvi
        </h3>
        <div class="multiline-text label">{{ selectShablonJson.value20 }}</div>
      </div>
    </div>
    <div v-else>
      <div
        style="font-size: 35px; font-weight: 600; text-align: center; font-family: 'Times New Roman';"
      >
        TUG'RUQ TIBBIY KARTA № 
      </div>
      <div>
        <label>F.I.O: {{ $store.state.bemor.fullname }}</label> <br/>
        <div class="display-flex">
          <label>Millati: {{ selectShablonJson.value7 }}</label>
          <label>Qabul qilingan vaqti: {{ selectShablonJson.value1 }}</label>
        </div>
          <label>Qon guruhi: {{ selectShablonJson.value8 }}</label>
          <label>Gemoglobini {{ selectShablonJson.value22 }}</label>
          <label>rezus mansubligi {{ selectShablonJson.value23 }}</label>
          <label>Antitelolar {{ selectShablonJson.value10 }}</label>
          <label>Tug'ruqxonadan chiqish vaqti: {{ selectShablonJson.value2 }}</label>
          <label>Allergik ta'sirchanligi: {{ selectShablonJson.value24 }}</label>
        <div>
          <label>Yotgan kunlar soni {{ selectShablonJson.value3 }}</label>
          <label>RW {{ selectShablonJson.value4 }}</label>
          <label>xona {{ selectShablonJson.value5 }}</label>
        </div>
        <div>
          <label>Suzuk bo'yicha tekshiruv {{ selectShablonJson.value6 }}</label>
        </div>
        <label>
          Doimiy yashash joyi
          {{
            $store.state.bemor.region ? $store.state.bemor.region.name : ""
          }}
          {{
            $store.state.bemor.district
              ? $store.state.bemor.district.name
              : ""
          }}
          {{ $store.state.bemor.addres }}
        </label>
        <div class="display-flex">
          <label>Oilaviy axvoli {{ selectShablonJson.value25 }}</label>
        </div>
        <label>Ish joyi, kasbi, lavozimi {{ selectShablonJson.value26 }}</label>
        <div class="display-flex">
          <label>Xomiladorlik vaqtida Shifokor (doya) nazoratida bo'lganmi {{ selectShablonJson.value27 }}</label>
          <label>Necha marta {{ selectShablonJson.value28 }}</label>
        </div>
        <label>Akusher-ginekolog tibbiy ko'rigi soni {{ selectShablonJson.value29 }}</label>
        <br>
        <label>Klinik tashxis: {{ selectShablonJson.value30 }}</label>
        <br>
        <label>Yakuniy tashxis: {{ selectShablonJson.value31 }}</label>
        <br>
        <label>Tug'ish jarayonida, tug'ruqdan keyingi asoratlar: {{ selectShablonJson.value32 }}</label>
        <label>O'tkazilgan jarroxlik amaliyoti nomi: {{ selectShablonJson.value33 }}</label>
        <label>{{ selectShablonJson.value34 }}</label>
        <label>(Ayolning o'zidan olingan ma'lumotlar)</label><br>
        <label>Umumiy xastalik {{ selectShablonJson.value35 }}</label>
        
        <label>Erining salomatligi {{ selectShablonJson.value36 }}</label>
        <label>Xayz ko'rish {{ selectShablonJson.value37 }}</label>
        
        <label>Yoshdan boshlangan {{ selectShablonJson.value38 }}</label>
        <label>(turmushga chiqqan)</label> <br>
        <label>Ginakologik kasalliklar {{ selectShablonJson.value39 }}</label>
        <label>Avvalgi xomiladorliklari {{selectShablonJson.value40}}</label>
        <label>necta bolasi hayot {{ selectShablonJson.value41 }}</label>
        <br>
        <label>O'lik tug'ilganlari {{ selectShablonJson.value42 }}</label>
        <br>
        <label>Nobut bo'lganlari {{ selectShablonJson.value43 }}</label>
        <label>Mazkur xomiladorlikning kechikishi va asoratlari {{ selectShablonJson.value44 }}</label>
        <label>Tug'ruq xonaga tushgan vaqtidagi holati {{ selectShablonJson.value45 }}</label>
        <br>
        <label>Ko'zdan kechirish natijalari {{ selectShablonJson.value46 }}</label>
        <label>Yuragi {{ selectShablonJson.value47 }}</label>
        <label>Tomir urishi {{ selectShablonJson.value48 }}</label>
        <label>O'ng qo'ldagi arterial qon bosimi {{ selectShablonJson.value49 }}</label>
        <label>Chap qo'ldagi arterial qon bosimi {{ selectShablonJson.value50 }}</label>
        <label>Nafas olish a'zolari {{ selectShablonJson.value51 }}</label>
        <label>Ovqat hazm qlish tizimi a'zolari {{ selectShablonJson.value52 }}</label>
        <label>Siydik-tanosil tizimi a'zolari {{ selectShablonJson.value53 }}</label>
        <label>Peshob sentrafugasi {{ selectShablonJson.value54 }}</label>
        <label>Shifokorning F.I.O imzo {{ selectShablonJson.value55 }}</label>
        <br/>
        <label>Bo'yi {{ selectShablonJson.value56 }}</label>
        <label>sm Vazni {{ selectShablonJson.value57 }}</label>
        <label>Xarorati {{ selectShablonJson.value58 }}</label>
        <br/>
        <label>Nechanchi xomiladorlish {{ selectShablonJson.value59 }}</label>
        <label>Nechanchi tug'ishi {{ selectShablonJson.value60 }}</label>
        <br/>
        <label>xomilaning brinchi bor qimirlashi {{ selectShablonJson.value61 }}</label>
        <br>
        <label>D. Sp {{ selectShablonJson.value62 }}</label>
        <label>D. Cr {{ selectShablonJson.value63 }}</label>
        <label>D. Tr {{ selectShablonJson.value64 }}</label>
        <label>T. vera {{ selectShablonJson.value65 }}</label>
        <br>
        <label>Qorin aylanishi {{ selectShablonJson.value66 }}</label>
        <label>sm</label>
        <label>Bachadon tubining balandligi {{ selectShablonJson.value67 }}</label>
        <label>sm</label>
        <br>
        <label>Xomila joylanishi, o'rni va ko'rinishi {{ selectShablonJson.value68 }}</label>
        <br>
        <label>Xomila yurak urishi, joyi, soni {{ selectShablonJson.value69 }}</label>
        <br>
        <label>Xomilaning oldin kelgan qismi {{ selectShablonJson.value70 }}</label>
        <br>
        <label>Joylashgan joyi {{ selectShablonJson.value71 }}</label>
        <label>Tug'ish faoliyati {{ selectShablonJson.value72 }}</label>
        <br>
        <label>Xomilaning taxminiy og'irligi {{ selectShablonJson.value73 }}</label>
        <br>
        <label>Shifokor {{ selectShablonJson.value74 }}</label>
        <br>
        <label>Doya {{ selectShablonJson.value75 }}</label>
        <br>
        <label>Chaqaloq gonoblenoreyaga qarshi muhofazalandi {{ selectShablonJson.value76 }}</label>
        <br>
        <label>Chaqaloqning Apgar shkalasi bo'yicha baxosi</label> <br>
        <label>Holati {{ selectShablonJson.value77 }}</label>
        <label>ball</label>
        <label>Tug'ruqdan {{ selectShablonJson.value78 }}</label>
        <br>
        <label>Bolalik joyi {{ selectShablonJson.value79 }}</label>
        <label>Qog'onog'i {{ selectShablonJson.value80 }}</label>
        <br>
        <label>Kindik uzunligi {{ selectShablonJson.value81 }}</label>
        <label>sm {{ selectShablonJson.value82 }}</label>
        <label>Atrofiga o'ralib qolgan: {{ selectShablonJson.value83 }}</label>
        <label>Hususiyati: {{ selectShablonJson.value84 }}</label>
        <label>Tugruq paytida kelgan qon {{ selectShablonJson.value85 }}</label>
        <label>ml.</label>
        <br>
        <label>Shifokorning F.I.O imzo {{ selectShablonJson.value86 }}</label>
        <h3 style="text-align: center; font-family: 'Times New Roman';">
          Tug'ruqning borishi
        </h3>
        <label>To'goq {{ selectShablonJson.value87 }}</label>
        <label>boshlandi Suv {{ selectShablonJson.value88 }}</label>
        <label>kela boshladi</label>
        <br>
        <label>Suvning hajmi, sifati {{ selectShablonJson.value89 }}</label>
        <br>
        <label>Bachadon to'la ochildi {{ selectShablonJson.value90 }}</label>
        <label>Kuchanish boshlandi {{ selectShablonJson.value91 }}</label>
        <br>
        <label><b>Bola tug'ildi:</b></label>
        <br>
        <label>Birinchisi {{ selectShablonJson.value92 }}</label>
        <label>{{ selectShablonJson.value93 }}</label>
        <br>
        <label>Jinsi {{ selectShablonJson.value94 }}</label>
        <label>vazni {{ selectShablonJson.value95 }}</label>
        <label>bo'yi {{ selectShablonJson.value96 }}</label>
        <label>Bosh aylanasi {{ selectShablonJson.value97 }}</label>
        <label>sm Ko'krak aylanasi {{ selectShablonJson.value98 }}</label>
        <br>
        <label>Ikkinchisi {{ selectShablonJson.value99 }}</label>
        <label>{{ selectShablonJson.value100 }}</label>
        <br>
        <label>Jinsi {{ selectShablonJson.value101 }}</label>
        <label>vazni {{ selectShablonJson.value102 }}</label>
        <label>bo'yi {{ selectShablonJson.value103 }}</label>
        <label>Bosh aylanasi {{ selectShablonJson.value104 }}</label>
        
        <label>sm Ko'krak aylanasi {{ selectShablonJson.value105 }}</label>
        <br>
        <label>Ruhiy muhofaza tayyorgarligi o'tkazildi, dori -darmonlar berildi, og'riqsizlantiruvchi vositalar qilindi {{ selectShablonJson.value106 }}</label>
        {{ selectShablonJson.value107 }}
        <br>
        <label><b>Tug'ruqning davom etishi</b></label>
        <br>
        <label>Umumiy {{ selectShablonJson.value108 }}</label>
        
        <label>I-davr {{ selectShablonJson.value109 }}</label>
        <label>II-davr {{ selectShablonJson.value110 }}</label>
        <label>III-davr {{ selectShablonJson.value111 }}</label>
        <label>Bolani qabul qilgan (doya, vrach F.I.O) {{ selectShablonJson.value112 }}</label>
        <label>Yo'ldoshni tekshiruvchi {{ selectShablonJson.value113 }}</label>
        <br>
        <label>Navbatchi virach {{ selectShablonJson.value114 }}</label>
        <br>
        <label>Doya {{ selectShablonJson.value115 }}</label>
      </div>
    </div>
    
  </div>
</template>

<script>
import PechatLogo from "../../Components/PechatLogo.vue";
import moment from "moment";
export default {
  components: {
    PechatLogo
  },
  data() {
    return {
      selectShablonJson: {},
      data: {}
    };
  },
  filters: {
    dateFormat: function(date) {
      if (date) {
        return moment.unix(date).format("DD.MM.YYYY");
      } else {
        return "";
      }
    }
  },
  created: function() {
    this.data = JSON.parse(localStorage.getItem("bayonnoma"));
    this.selectShablonJson = JSON.parse(this.data.value.toString());
  },
  mounted() {
    localStorage.removeItem("bayonnoma");
    window.print();
    setTimeout(() => {
      //   this.$router.push({ path: "/user" });
      window.close();
    }, 3000);
  }
};
</script>

<style lang="scss">
.multiline-text {
  white-space: pre-line;
}

.display-flex {
  display: flex;
}
.bayonnoma-style {
  page-break-after: always;
  .label, label {
    font-family: "Times New Roman", Times, serif;
    margin-top: 10px;
    font-size: 16pt;
    font-weight: 500;
    margin-right: 5px;
  }
}
</style>
